import '@/assets/css/style.sass'
import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './i18n'
import VCalendar from 'v-calendar'
import Vuelidate from 'vuelidate'
import DatePickerScroll from 'vue-datepicker-scroll'
import VueMask from 'v-mask-persian'
import VueScrollTo from 'vue-scrollto'
import EventEmitter from './plugins/event-emitter'
import { BaseInput, BaseButton } from 'qic-components'
Vue.config.productionTip = false

Vue.use(VCalendar, {})
Vue.use(Vuelidate)
Vue.use(DatePickerScroll)
Vue.use(VueMask)
Vue.use(VueScrollTo)
Vue.use(EventEmitter)

Vue.component('BaseInput', BaseInput)
Vue.component('BaseButton', BaseButton)

Vue.filter('splitNumber', (value) => value ? value.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1,') : '')

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
